import { render, staticRenderFns } from "./TrainingCategoriesDetails.vue?vue&type=template&id=094177e1&"
import script from "./TrainingCategoriesDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingCategoriesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports